export default __webpack_public_path__ + "static/media/r6s_logo_tch.b8c0fa3e.png";